import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Navbar from '../components/UI/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Competencies from '../components/Competencies';
import Experience from '../components/Experience';
import Projects from '../components/Projects';
import OtherProjects from '../components/OtherProjects';
import Skills from '../components/Skills';
import Education from '../components/Education';
import Contact from '../components/Contact';
import Divider from '../components/UI/Divider';

const HomePage = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: 'ease-out',
      offset: 100,
    });

    AOS.refresh();
  }, []);

  return (
    <div className="min-h-screen bg-darkBg">
      <Navbar />

      <main>
        <Hero />

        <Divider quoteIndex={0} />

        <About />

        <Divider quoteIndex={1} />

        <Competencies />

        <Experience />

        <Divider quoteIndex={2} />

        <Projects />

        <OtherProjects />

        <Skills />

        <Divider quoteIndex={3} />

        <Education />

        <Contact />
      </main>
    </div>
  );
};

export default HomePage;
